import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false


/*khai báo RawLoader */
import RawLoader from "@/components/ComRawLoader.vue";//<--------------------------------------------add here
Vue.component('raw-loader',RawLoader)

import VueKonva from 'vue-konva';
Vue.use(VueKonva);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
